"use strict"

import React, { useEffect, useState } from "react"
import { Modal, Button } from "react-bootstrap"
import { FormattedMessage } from "react-intl"

import { API_STATUS } from "../../../shared_components/widgets/utils"
import InventoryItemDetails from "./InventoryItemDetails"

export default function ModalAlterInventoryItem({
  inventory_item = {},
  onHide,
  show,
  icon,
  btn_type,
  title_id,
  max_quantity,
  status,
  onSubmit,
  quantity_msg_id,
  reason_msg_id,
  isDeplete = false,
}) {
  const [status_submit, setStatusSubmit] = useState(null)

  useEffect(() => {
    setStatusSubmit(status)
  }, [status])

  const [formValues, setFormValues] = useState({
    quantity: "",
    reason: "",
  })

  const onChangeValue = (e) => {
    setFormValues({
      ...formValues,
      [e.target.name]: e.target.value,
    })
  }

  return (
    <Modal size={"lg"} show={show} onHide={onHide} backdrop={"static"} keyboard={true}>
      <Modal.Header closeButton>
        <Modal.Title>
          <i className={icon} />
          &nbsp;&nbsp;
          <FormattedMessage id={title_id} />
          &nbsp;
          <span>
            - '{inventory_item.sku.name} ({inventory_item.sku.inventory_type.name})'
          </span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ width: "700px" }}>
          <form name={"form_alter_item"} onSubmit={(e) => onSubmit(e, formValues)}>
            <table className={"table table-sm"}>
              <tbody>
                <InventoryItemDetails inventory_item={inventory_item} />
                <tr>
                  <td>
                    <label>
                      <FormattedMessage id={quantity_msg_id} />
                    </label>
                    * :
                  </td>
                  <td>
                    <input
                      type={"number"}
                      name={"quantity"}
                      className={"form-control form-control-sm"}
                      style={{ width: "170px" }}
                      required={true}
                      min={"1"}
                      max={max_quantity || null}
                      value={formValues.quantity}
                      onChange={onChangeValue}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>
                      <FormattedMessage id={reason_msg_id} />
                    </label>
                    * :
                  </td>
                  <td>
                    <input
                      type={"text"}
                      name={"reason"}
                      className={"form-control form-control-sm"}
                      required={true}
                      value={formValues.reason}
                      onChange={onChangeValue}
                    />
                  </td>
                </tr>
              </tbody>
            </table>

            <div align={"center"}>
              {status_submit === API_STATUS.LOADING && (
                <div>
                  <div className="spinner-border spinner-border-sm text-primary text-center" role="status" />
                  &nbsp;
                  <FormattedMessage id={"general.saving"} />
                  ...
                </div>
              )}
              {status_submit === null && (
                <button
                  className={`btn ${btn_type}`}
                  type={"submit"}
                  disabled={isDeplete && inventory_item.available_quantity === 0}
                >
                  <span className={`${icon} text_white`} />
                  &nbsp;&nbsp;
                  <FormattedMessage id={title_id} />
                </button>
              )}
            </div>
          </form>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant={"outline-primary"} onClick={onHide} style={{ display: "flex", float: "right" }}>
          <FormattedMessage id={"general.closeButton"} />
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
